import { Image } from '../../../services/shared/shared-interface';

export interface CommonError {
  state: CommonErrorState;
}
export interface CommonErrorState {
  id: string;
  messages: MessageState[]; 
 
  statusCode: number;
  image?: Image; 
  action?: string;
}

export interface MessageState {
  message: string;
  cssClass?: string;
}
